export enum SubscriptionSourceType {
  Unknown = 0,
  ProjectComment = 1,
  EventComment = 2,
  EventAttendance = 3,
  Subscription = 4,
  S123 = 5,
  Import = 6,
  PIMA = 7,
  ExternalApp = 8,
  RSVP = 9,
  Discussions = 10,

  // Constant Contact Sources are 200+
  Contact = 200, // Contact themselves subscribes or unsubscribes

  Account = 201, // Account owner manually subscribes or unsubscribes a contact
  Bounce = 203, // Contact is unsubscribed due to a bounce
}
